import React, { useEffect, useState } from "react"
import LayoutDemolition from "../components/layout-demolition"
import Container from "../components/layout/container"
import Content from "../components/content/Content"
import Sidebar from "../components/content/Sidebar";
import Box from "../components/content/Box";
import SchemaStars from "../components/schemastars"
import Stars from "../components/stars"
import Anchor from "../components/content/Anchor";
import Lightbox from "../components/content/Lightbox";
import TextWithTeaser from "../components/content/TextWithTeaser";
// import OnOff from "../components/content/OnOff";
import QuoteRequestModalLibrary from "../components/quote-request-modal-library"
import {ApolloClient, InMemoryCache, HttpLink} from '@apollo/client'
import {GET_PAGINATION_REVIEWS} from '../components/paginationQueryDefinition'
import Pagination from "../components/pagination";
import ClaimedStatus from "../components/claimed-status";
import VerifyBusinessCard from "../components/verify-business-card";
import { trackSimpleEvent } from "../helpers/helpers";
// import Img from 'gatsby-image';

const defaultOptions = {
    watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore',
    },
    query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
    },
}

const defaultTabs = [
    {
        value: 'overview',
        label: 'Overview',
    },
    {
        value: 'photos',
        label: 'Photos',
    },
    {
        value: 'reviews',
        label: 'Reviews',
    },
]

const PROFILELANDINGPAGEDEMOLITION = ({ pageContext }) => {
    const page = pageContext
    const code = page.code
    const env = page.env
    const profile = page.profile
    const posts = page.reviews
    const paginationInfo = pageContext.pagination; 
    const proId = page.profile.profile.id
    const permanentlyClosed = profile.profile.permanentlyClosed;

    const [tabs, setTabs] = useState(defaultTabs);
    const [selectedTab, setSelectedTab] = useState('overview');
    const [showMore, setShowMore] = useState(false);
    const [reviews, setReviews] = useState(posts);
    const [pagination, setPagination] = useState(paginationInfo);
    const [showPhone, setShowPhone] = useState(false);

    const isProSponsored = (proData) => {
        return proData?.db && Number(proData.db) > 0;
    };

    const showDefaultPlaces = () => {
        let auxArr = [];
        profile.areas?.forEach(area => {
            auxArr.push({ state: area.state, status: false })
        })
        return auxArr;
    }
    const [showPlaces, setShowPlaces] = useState(showDefaultPlaces());

    useEffect(() => {
        const pro = profile?.profile;

        if (!pro?.id || pro?.db === undefined || pro?.db === null) return;
        const sponsored = isProSponsored(pro);
        const proId = pro.id;
        if(proId) {
            if (sponsored) {
                trackSimpleEvent("sponsoredProPageVisible", proId);
            } else {
                trackSimpleEvent("proPageVisible", proId);
            }
        }

    }, [profile?.profile?.id, profile?.profile?.db])

    useEffect(() => {
        (async () => {
            let temporalTabs = defaultTabs;
            if(profile.photos?.length === 0){
                temporalTabs = temporalTabs.filter(tab => tab.value !== 'photos')
            }
            setTabs([...temporalTabs])
            window.addEventListener('scroll', () => showScrollTop(temporalTabs));
            return () => window.removeEventListener('scroll', () => showScrollTop(temporalTabs));
        })()
    }, [])

    // SEO
    const getSeoDesc = (profile) => {
        return profile.description.replace(/(<([^>]+)>)/gi, "").replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&')
    }

    const getSeoTitle = (profile) => {
        return profile.name + ', ' + profile.profile.add_c + ', ' + profile.profile.add_av
    }

    const seoImage = (image) => {
        if (image.path !== undefined) {
            return image.path
        }

        return false
    }
    
    const seo =
    {
        url: profile.url,
        env: env,
        title: getSeoTitle(profile),
        description: getSeoDesc(profile),
        code: code,
        page: 'profile',
        image: seoImage(profile.profile.logo),
        schema: page.schemaOrg
    }

    const BreadCrumb = () => {
        const links = profile.breadcrumb || [];

        if (links.length === 0) return null;

        return (
            <Container classes="bread">
                <div className="col-12 breadcrumb-scroll">
                    {links.map((link, index) => (
                        <React.Fragment key={`${link.url}-${index}`}>
                            <a
                            href={link.url}
                            title={link.html_title || link.label}
                            className="breadcrumb-link"
                            >
                                {link.label}
                            </a>

                            {index < links.length - 1 && (
                            <span className="breadcrumb-separator">{'>'}</span>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </Container>
        );
    }

    const ProCardBanner = () => {
        const rates = page.totalReviews;
        const services = profile.serviceslinks[0]


        const ServicesLinks = () => {
            services.sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0))

            return (
                <ul className="service_links">
                    {
                        services.map(service => {
                            if (service) {
                                return (
                                    <li><a href={service.url}>{service.label}</a></li>
                                )
                            }

                            return <></>
                        })
                    }
                </ul>
            )
        }

        const CompanyTags = () => {
            if(profile.profile && profile.profile.company_tags?.length > 0){
                return (
                    <ul class='company-tags'>
                        {profile.profile.company_tags.map((tag, index) => (
                            <li key={index}>{tag}</li>
                        ))}
                    </ul>
                )
            }
            return <></>
        }

        const imgUrl = (image) => {
            const img = image.localFile.publicURL !== null ? image.localFile.publicURL : ''
            let thumb = img

            if(image.localFile.childImageSharp !== null){
                if(image.localFile.childImageSharp !== undefined){
                    thumb = image.localFile.childImageSharp.gatsbyImageData.images.fallback.src
                }    
            }

            return thumb
        }

        const handleClick = () => {
            const btn = document.getElementsByClassName('lightbox-btn');
            if(btn?.length > 0){
                btn[0].click();
            }else{
                handleChangeTab({
                    value: 'photos',
                    label: 'Photos',
                });
            }
        }

        return (
            <div className="profile-banner">
                <div className="profile-banner">
                    <div className="row">
                        <div className="col-12">
                            <div className="post">
                                <div className={`top-content1${profile.photos?.length === 0 ? ' full-width' : ''}`}>
                                    <h1 className="main-title"><span>{profile.name}</span></h1>
                                    <h3>
                                        {profile.profile.address_alternative}
                                        <span className="claimed-status-separator"> • </span>
                                        <ClaimedStatus claimed={profile.profile.claimed} proId={proId} bookableUrl={page.bookableUrl} />
                                    </h3>
                                    <SchemaStars reviews={paginationInfo.totalCount} profile calculate={rates} page='profile'/>
                                    <ServicesLinks />
                                    <CompanyTags />
                                    <div className="mobile-btn">
                                        <button className="btns" onClick={() => handleChangeTab({ value: 'reviews', label: 'Reviews' })}><span className="star-btn"/> Write a review</button>
                                        {profile.profile.phone && <a className="btns" href={'tel:' + profile.profile.phone}><span className="phone-btn" title="provider phone number"/> <span className="pro-phone-cont" data-proid={profile.profile.id}>Call</span></a>}
                                        {addWebsite("btns")}
                                    </div>
                                    { !profile.except ?
                                    <div className="actions">
                                        <QuoteRequestModalLibrary
                                        // showButton={true}
                                        startVisible={false}
                                        proid={proId}
                                        class="get-a-quote"
                                        ondeffCode='demolitionQuoteRequest' /> 
                                    </div>
                                    : (profile.profile.phone &&
                                        <>
                                            <div className="phonemanager mobile">
                                                <span className="phone-btn" title="provider phone number"/>
                                                <strong><span className="phone" style={{fontSize: '20px'}}><a href={'tel:' + profile.profile.phone}><span className="pro-phone-cont" data-proid={profile.profile.id}>{profile.profile.phone}</span></a></span></strong>
                                            </div>
                                            <div className="phonemanager desktop" data-proid={profile.profile.id}>
                                                <span className="phone-btn" title="provider phone number"/>
                                                <strong><span className="phone" style={{fontSize: '20px'}}><a href={'tel:' + profile.profile.phone}><span className="pro-phone-cont" data-proid={profile.profile.id}>{profile.profile.phone}</span></a></span></strong>
                                            </div>
                                        </> 
                                    )
                                    }
                                </div >
                                {profile.photos?.length > 0 && profile.photos[0].localFile &&
                                <div className="top-content2" onClick={handleClick}>
                                    <div className="img-container">
                                        <img src={imgUrl(profile.photos[0])} alt={profile.photos[0].alt ? profile.photos[0].alt : profile.name}/>
                                        <div className="img-btn" onClick={handleClick}>
                                            {`See ${profile.photos.length} photos`}
                                        </div>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }

    const addWebsite = (c) => {
        const unpaid = profile.profile.unpaid
        if (unpaid || profile.profile.website === '') return <></>

        const website = c ? 'Website' : (profile.profile.website.length > 35 ? 'Website' : profile.profile.website)

        return (
            <div className={c ? `websitemanager ${c}` : "websitemanager"}>

                <span className="web-btn" title="provider website"/>

                <span className="website"><a target="_blank" className="pro-website-cont" data-proid={profile.profile.id} href={profile.profile.website}><span className="pro-website-cont" data-proid={profile.profile.id}>{website}</span></a></span>

            </div>
        )
    }

    const SidebarCard = () => {
        const hideAddress = profile.profile.hide_address

        const addPhone = (phone) => {
            if (phone !== '') {
                return (
                    <>
                        <div className="phonemanager mobile">
                            <span className="phone-btn" title="provider phone number"/>
                            <span className="phone"><a href={'tel:' + phone}><span className="pro-phone-cont" data-proid={profile.profile.id}>Call</span></a></span>
                        </div>
                        <div className="phonemanager desktop" data-proid={profile.profile.id}>
                            <span className="phone-btn" title="provider phone number"/>
                            <span className="phone"><span className="on-click-phone" onClick={() => setShowPhone(true)}><span className="pro-phone-cont" data-proid={profile.profile.id}>{showPhone ? phone : 'View phone'}</span></span></span>
                        </div>
                    </>
                )
            }

            return <></>;
        }

        const addLogo = (image, name) => {
            if (image.path !== undefined) {
                return (
                    <div className="images">
                        <div className="image-container">
                            <picture>
                                <source media="(min-width: 769px)" title={name + ' logo'}  srcset={image.path}/>
                                <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7 1w" alt={name + ' logo'} loading="eager"/>
                            </picture>
                        </div>
                    </div>
                )
            }

            return (
                <div class='logo-container'>
                    <div class='logo-name'>
                        {/*Get the first two initial letters of the company name */}
                        {profile.name.match(/\b\w/g).join('').slice(0, 2)}
                    </div>
                </div>
            )
        }

        const addAddress = () => {
            if (hideAddress) {
                return (
                    <ul className="address" >
                        {profile.profile.address_alternative && <li className="street"><span className="address-btn" title="provider address"/>  {profile.profile.address_alternative}</li>}
                    </ul>
                )
            }

            return (
                <ul className="address">
                    {profile.profile.address !== '' && <li className="street"><span className="address-btn" title="provider address"/>  {profile.profile.address}</li>}
                    {profile.profile.address_extras && <li className="region">{profile.profile.address_extras}</li>}
                </ul>
            )
        }

        return (
            <div className="info">
                {addLogo(profile.profile.logo, profile.name)}
                {addAddress()}
                <div className="phone_box">
                    {addPhone(profile.profile.phone)}
                </div>              
                <div className="webiste_box">
                    {addWebsite()}
                </div>
                {!profile.except &&
                    <QuoteRequestModalLibrary
                    // showButton={false}
                    // showButtonForProfile={true}
                    startVisible={false}
                    proid={proId}
                    class="profile-button-form"
                    ondeffCode= 'demolitionQuoteRequest' />
                }
            </div>
        )
    }

    const Description = () => {
        if (profile.description === '') return <></>

        return (
            <div id='overview' className="profile-description">
                <h2>Description</h2>
                <Anchor name="profile" />
                <TextWithTeaser danger={true}>{profile.description}</TextWithTeaser>
            </div>
        )
    }

    const Services = () => {
        const services = profile.services[0].length > 0 ? profile.services[0] : []

        services.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))

        if (services.length <= 0) return <></>

        const projectTypes = () => {
            const types = []

            services.map(service => {
                service.types.map(type => {
                    types.push(type)
                })
            })

            types.sort()

            return types
        }
        const serviceLength = projectTypes()?.length;

        return (
            <div className="profile-services">
                <h2>Services</h2>
                <Anchor name="services" />
                <ul className="names">
                    {
                        services.map(service => {
                            return <li>{service.name}</li>
                        })
                    }
                </ul>
                <ul className="profile-project-types">
                    {
                        projectTypes().slice(0, (!showMore ? 15 : serviceLength)).map(type => {
                            return <li data-type={type.replace(/ /g, '-').toLowerCase()}>{type}</li>
                        })
                    }
                </ul>
                {serviceLength > 15 &&
                <p className="service-btn" onClick={() => setShowMore(true)}>{(showMore) ? '' : 'View all project types >'}</p>
                }
            </div>
        )
    }

    const Photos = () => {
        const photos = profile.photos

        if (photos.length <= 0) return <></>

        return (
            <div id='photos' className="profile-photos">
                <h2>Photos</h2>
                <Anchor name="photos" />
                <Lightbox images={profile.photos} globalt={profile.name} />
            </div>
        )
    }

    const Reviews = ({ proId }) => {
        const [currentPage, setCurrentPage] = useState(pagination?.currentPage)
        const [hasPreviousPage, setHasPreviousPage] = useState(pagination?.hasPreviousPage)
        const [hasNextPage, setHasNextPage] = useState(pagination?.hasNextPage)
        const [reviewsPerPage, setReviewsPerPage] = useState(20)
        const [lastPage, setLastPage] = useState(pagination?.pageCount)

        const headers = {};
        headers['Ocp-Apim-Subscription-Key'] = process.env.GATSBY_API_MANAGMENT_KEY;

        const client = new ApolloClient({
            link: new HttpLink({ uri: `${process.env.GATSBY_BOOKABLE_SEARCH_API}`,headers: headers}),
            cache: new InMemoryCache(),
            defaultOptions: defaultOptions
        })

        const getReviewTitle = (review) => {
            let str = '';
            if (review.customer === 'Name Withheld') {
                str = `Review from ${review.place}`;
            } else {
                str = `Review by ${review.customer}${(review.place === '' ? '' : ` in ${review.place}`)}`;
            }
            return str;
        }
      
        const makeQueryPagination = (page) => {
            let vars = {
                page: page,
                limit: reviewsPerPage,
                proId,
                site: env.site
            }
            client.query({
                query: GET_PAGINATION_REVIEWS,
                variables: vars
            }).then(result => {
                setReviews(result.data.paginationReviewsDefinition.posts)
                setLastPage(result.data.paginationReviewsDefinition.pageInfo.pageCount)
                setHasPreviousPage(result.data.paginationReviewsDefinition.pageInfo.hasPreviousPage)
                setHasNextPage(result.data.paginationReviewsDefinition.pageInfo.hasNextPage);
                setPagination(result.data.paginationReviewsDefinition.pageInfo)
            })
        }

        if (reviews.length <= 0)
            return (
                <div id='reviews' className="profile-reviews">
                    <h2>Verified Reviews</h2>
                    <Anchor name="reviews" />
                    <div className="write">
                        <div class="text">Be the first to add a review for {profile.name}</div>
                        <QuoteRequestModalLibrary
                            // showButton={false}
                            // showButtonForProfile={true}
                            startVisible={false}
                            proid={profile.profile.id}
                            ondeffCode= 'reviewForm'
                            btnLabel="Write a review"
                            class="profile-button-review-form"
                            title= {profile.profile.name}
                            initialFormData={[{ key: 'pro_id', value: profile.profile.id }, { key: 'pro_name', value: profile.profile.name }]}
                        />
                    </div>
                </div>
            )

        return (
            <div id='reviews' className="profile-reviews">
                <h2>Verified Reviews</h2>
                <Anchor name="reviews" />
                <div className="write">
                    <span>{profile.name}</span>
                    <QuoteRequestModalLibrary
                        // showButton={false}
                        // showButtonForProfile={true}
                        startVisible={false}
                        proid={profile.profile.id}
                        ondeffCode= 'reviewForm'
                        btnLabel="Write a review"
                        class="profile-button-review-form"
                        title= {profile.profile.name} 
                        initialFormData={[{ key: 'pro_id', value: profile.profile.id }, { key: 'pro_name', value: profile.profile.name }]}
                    />
                </div>
                <div className="blogs">
                        {
                            reviews.map((review, index) => {
                                return (
                                    <div key={index} className="single-item review">
                                        <Stars rate={review.stars} page='profile'/>
                                        <div className="user">{getReviewTitle(review)}</div>
                                        <p>{review.text}</p>
                                    </div>
                                )
                            })
                        }
                </div>
                <Pagination class="pagination"
                    currentPage={currentPage}
                    hasPreviousPage={hasPreviousPage}
                    hasNextPage={hasNextPage}
                    lastPage={lastPage}
                    makeQueryPagination={makeQueryPagination}
                    setCurrentPage={setCurrentPage}
                    whoIsCalling='reviews'
                />
            </div>
        )
    }

    const Areas = () => {
        const areas = profile.areas

        if (areas.length <= 0) return <></>
        if (profile.except) return (
            <div className="profile-areas">
                <h2>Cities Served</h2>
                <p>Nationwide service area</p>
            </div>
        )

        return (
            <div className="profile-areas">
                <h2>Cities Served</h2>
                <Anchor name="areas" />
                <ul className="areas">
                    {
                        areas.map(area => {
                            const name = Math.random().toString(36).substr(2, 9)
                            const toggle = (state) => {
                                const target = showPlaces.find(place => place.state === state)
                                if(target){
                                    target.status = !target.status
                                    setShowPlaces([...showPlaces])
                                }
                            }
                            const isOpened = showPlaces.find(place => place.state === area.state)?.status;

                            return (
                                <li className="area">
                                    <h4 data-target={name} onClick={() => toggle(area.state)} className={isOpened ? 'open' : ''}>{area.state} <span className="plus" title="show service area details"/> <span className="less" title="hide service area details"/></h4>
                                    <ul className={isOpened ? `places ${name} on` : `places ${name}`}>
                                        {
                                            area.places.map(place => {
                                                return <li>{place}</li>
                                            })
                                        }
                                    </ul>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        )
    }

    const handleChangeTab = (tab) => {
        setSelectedTab(tab.value);
        const element = document.getElementById(tab.value);
        let headerOffset = 130;
        if(window.screen.width < 769){
            headerOffset = 180;
        }
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - headerOffset;
    
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const TopMenu = () => {
        return (
            <div className='custom-tab-container col-8'>
            { tabs.map((tab) => (
                <React.Fragment
                    key={`tab-${tab.label}`}
                >
                    <div
                        key={`tab-${tab.label}`}
                        className='custom-tab'
                        onClick={() => {handleChangeTab(tab)}}
                    >
                        <p
                        className={selectedTab === tab.value ? 'tab-label active-tab' : 'tab-label'}
                        >
                        {tab.label}
                        </p>
                    </div>
                </React.Fragment>
                ))}
            </div>
        )
    }

    const showScrollTop = (tabs) => {
        let obj = {};
        tabs.forEach((tab,index) => {
            obj[index] = document.getElementById(tab.value)?.offsetTop;
        })
        let headerOffset = 150;
        if(window.screen.width < 769){
            headerOffset = 190;
        }
        const currentOffsetTop = window.scrollY + headerOffset
        const lastItem = Object.keys(obj)?.length - 1;
        for(const property in obj){
            if(currentOffsetTop < obj[0]){
                setSelectedTab(tabs[0].value)
                break;
            }
            else if(currentOffsetTop > obj[property] && currentOffsetTop < obj[`${+property + 1}`]){
                setSelectedTab(tabs[property].value);
                break;
            }
            else if(currentOffsetTop > obj[lastItem]){
                setSelectedTab(tabs[lastItem].value)
                break;
            }            
        }     
    }

    return (
        <LayoutDemolition seo={seo} env={env} bgcolor={'#f5f5f5'}>
            <div className="profile-landing-page" data-proid={profile.profile.id} id="profile-landing-page">
                <BreadCrumb />
                <Container>
                    <Content width="col-12">
                        <Box>
                            {permanentlyClosed && <p className="permanentlyClosedBanner rounded">Permanently closed</p>}
                            <ProCardBanner />
                        </Box>
                    </Content>
                </Container>
                <Container classes='menu-bar demolition'>
                    <Content width="col-12">
                        <Box>
                            <TopMenu />
                        </Box>
                    </Content>
                </Container>
                <Container>
                    <Content>
                        <Box>
                            <Description />
                            <Services />
                            <Photos />
                            <Reviews proId={pageContext.profile.profile.id}/>
                            <Areas />
                        </Box>
                        {!profile.profile.claimed &&
                            <Box classes="rounded white verify-business-mobile-only">
                                <VerifyBusinessCard proId={proId} bookableUrl={page.bookableUrl} />
                            </Box>
                        }
                    </Content>
                    <Sidebar>
                        <Box>
                            <SidebarCard />
                        </Box>
                        {!profile.profile.claimed &&
                            <Box>
                                <VerifyBusinessCard proId={proId} bookableUrl={page.bookableUrl} />
                            </Box>
                        }
                    </Sidebar>
                </Container>
            </div>
        </LayoutDemolition>
    )
};

export default PROFILELANDINGPAGEDEMOLITION;